import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ContainerV2, H1, P } from "../../Atoms";
import { CardStoreList } from "./Components/CardStoreList";
import { useStoreV2 } from "./useStoreV2";
import { Tracking } from "../../../services/Tracking";
import { isAgendamentoLotePath } from "../../../hooks/useAgendamentoStepIndicator/agendamentoV2Steps";

export const StoreV2 = () => {
  const location = useLocation();
  const { stepIndicator, lojas, uuidLoja, setUuidLoja, submitAgendamento } =
    useStoreV2();

  useEffect(() => {
    const pageviewEvent = isAgendamentoLotePath(location.pathname)
      ? "mapa:agendamento-lote/loja:pageview"
      : "mapa:agendamento/loja:pageview";
    Tracking.pageView(pageviewEvent);
  });

  return (
    <ContainerV2
      nextButton={{
        title: "Avançar",
        disabled: !uuidLoja,
        onClick: submitAgendamento,
      }}
    >
      {stepIndicator}
      <H1 className="mb-4 mt-8">Loja / Ciretran</H1>
      <P className="mb-6">
        Selecione a unidade mais próxima ou a que melhor se encaixa na sua
        rotina.
      </P>

      <CardStoreList stores={lojas} onValueChange={setUuidLoja} />
    </ContainerV2>
  );
};
